import React, { Component } from "react";
import PropTypes from "prop-types";
import { Radio, FormGroup, Button, ListGroup, ListGroupItem } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { isEqual, pick } from "@utils/lodash";
import utils from "@utils";
import { LOCATION_DENIAL_UNASSIGN_ACTIONS } from "@constants";
import Actions, { thunks } from "@redux/admin";
import GlobalsActions from "@redux/globals";
import { Modal } from "../../../components";

class LocationDenialUnassignModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			validation: null,
		};
	}

	shouldComponentUpdate = ({ show, officerAction }, { validation }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(lastState.validation, validation) ||
			!isEqual(lastProps.show, show) ||
			!isEqual(lastProps.officerAction, officerAction)
		);
	};

	onCancel = () => {
		const { setModalOpen, changeState } = this.props;

		setModalOpen("locationApprovals", "locationDenialUnassign", false);
		changeState(
			"admin",
			["locationApprovals", "modals", "locationDenialUnassign", "officerAction"],
			"",
		);
		this.setState({ validation: null });
	};

	onFieldChange = property => event => {
		let { value } = event?.target || {};

		if (value === undefined) {
			({ value } = event);
		}

		const { changeState } = this.props;
		changeState(
			"admin",
			["locationApprovals", "modals", "locationDenialUnassign", property],
			value,
		);
	};

	onProceed = () => {
		const {
			updateLocationById,
			updateMultipleLocations,
			updateSingleStatus,
			updateMultipleStatus,
			selectedLocations,
			officerAction,
			multiple,
			LocationId,
			LocationGroupId,
			LocationName,
		} = this.props;
		let unassign;

		if (officerAction === "") {
			this.setState({ validation: "error" });
			return;
		}

		switch (officerAction) {
			case "keep":
				unassign = LOCATION_DENIAL_UNASSIGN_ACTIONS.KEEP;
				break;
			case "remove":
				unassign = LOCATION_DENIAL_UNASSIGN_ACTIONS.DELETE;
				break;
			default:
				unassign = LOCATION_DENIAL_UNASSIGN_ACTIONS.DEFAULT;
		}

		this.setState({ validation: null });

		if (multiple) {
			if (updateMultipleStatus) {
				updateMultipleStatus(selectedLocations, unassign);
			} else {
				updateMultipleLocations(selectedLocations, unassign);
			}
		} else if (updateSingleStatus) {
			updateSingleStatus(
				{
					LocationId,
					LocationGroupId,
					LocationName,
					Approved: false,
				},
				unassign,
			);
		} else {
			updateLocationById(
				{
					LocationId,
					LocationGroupId,
					LocationName,
					Approved: false,
				},
				unassign,
			);
		}

		this.onCancel();
	};

	render() {
		const { lang } = global;
		const { show, officerAction, multiple, JobEventsWithAssignedOfficers, TimeZoneId } =
			this.props;
		const { validation } = this.state;

		return (
			<Modal
				backdrop="static"
				show={show}
				onHide={this.onCancel}
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Denied Location with Officers")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Choose>
						<When condition={multiple}>
							<p>
								{lang.t(
									"One or more locations you selected has jobs with officers assigned_",
								)}
							</p>
						</When>
						<Otherwise>
							<p>{lang.t("There are officers assigned to jobs at this location_")}</p>
						</Otherwise>
					</Choose>
					<If condition={JobEventsWithAssignedOfficers?.length > 0}>
						<ListGroup>
							<For
								index="index"
								each="job"
								of={JobEventsWithAssignedOfficers}
							>
								<ListGroupItem
									key={`location_${index}_of_${job.JobEventId}`}
									href={`/jobs/${job.JobEventId}`}
									target="_blank"
									rel="noopener noreferrer"
									header={`Job #${job.JobEventId}`}
									bsStyle="warning"
								>
									{`"${job.JobEventName}" for ${job.ClientName}, from ${utils.formatTime(
										`${job.StartDateTime}Z`,
										"en-US",
										TimeZoneId,
										"dt-num",
									)} to ${utils.formatDate(`${job.EndDateTime}Z`, "en-US", TimeZoneId, "dt-num")}`}
								</ListGroupItem>
							</For>
						</ListGroup>
					</If>
					<p>{lang.t("Do you want to remove them, or keep them_")}</p>
					<FormGroup validationState={validation}>
						<Radio
							name="radioGroup"
							value="keep"
							onChange={this.onFieldChange("officerAction")}
							checked={officerAction === "keep"}
						>
							{lang.t("Keep")} {lang.t("Officers")}
						</Radio>
						<Radio
							name="radioGroup"
							value="remove"
							onChange={this.onFieldChange("officerAction")}
							checked={officerAction === "remove"}
						>
							{lang.t("Remove")} {lang.t("Officers")}
						</Radio>
					</FormGroup>
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={this.onCancel}
						bsStyle="danger"
					>
						Cancel
					</Button>
					<Button
						onClick={this.onProceed}
						bsStyle="primary"
					>
						Proceed
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

const mapStateToProps = ({
	app: {
		user: { TimeZoneId },
	},
	admin: {
		locationApprovals: {
			modals: {
				locationDenialUnassign: {
					show,
					officerAction,
					settings: {
						multiple,
						selectedLocations,
						LocationId,
						LocationName,
						LocationGroupId,
						JobEventsWithAssignedOfficers,
					},
				},
			},
		},
	},
}) => ({
	TimeZoneId,
	show,
	officerAction,
	multiple,
	selectedLocations,
	LocationId,
	LocationName,
	LocationGroupId,
	JobEventsWithAssignedOfficers,
});

const mapDispatchToProps = dispatch => ({
	...pick(bindActionCreators(Actions, dispatch), ["setModalOpen"]),
	...pick(bindActionCreators(GlobalsActions, dispatch), ["changeState"]),
	...pick(bindActionCreators(thunks, dispatch), [
		"updateLocationById",
		"updateMultipleLocations",
	]),
});

LocationDenialUnassignModal.propTypes = {
	JobEventsWithAssignedOfficers: PropTypes.array,
	LocationGroupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	LocationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	LocationName: PropTypes.any,
	TimeZoneId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	changeState: PropTypes.func.isRequired,
	multiple: PropTypes.bool,
	officerAction: PropTypes.string,
	selectedLocations: PropTypes.array,
	setModalOpen: PropTypes.func.isRequired,
	show: PropTypes.bool,
	updateLocationById: PropTypes.func,
	updateMultipleLocations: PropTypes.func,
	updateSingleStatus: PropTypes.func,
	updateMultipleStatus: PropTypes.func,
};

LocationDenialUnassignModal.defaultProps = {
	JobEventsWithAssignedOfficers: [],
	LocationGroupId: "",
	LocationId: "",
	LocationName: "",
	multiple: false,
	selectedLocations: [],
	show: false,
	officerAction: "",
	updateSingleStatus: undefined,
	updateMultipleStatus: undefined,
	updateMultipleLocations: undefined,
	updateLocationById: undefined,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationDenialUnassignModal);
